import { DialogRef } from '@angular/cdk/dialog';
import { Component } from '@angular/core';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-unavailable-documents',
  imports: [ButtonComponent],
  standalone: true,
  styleUrl: './unavailable-documents.component.scss',
  templateUrl: './unavailable-documents.component.html',
})
export class UnavailableDocumentsComponent {
  constructor(public dialogRef: DialogRef<boolean>) {}
}
